import { render, staticRenderFns } from "./ed-list-class-courses.component.vue?vue&type=template&id=61ce9dac&scoped=true&"
import script from "./ed-list-class-courses.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-class-courses.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-class-courses.component.scss?vue&type=style&index=0&id=61ce9dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce9dac",
  null
  
)

export default component.exports